import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import PersonIcon from "@mui/icons-material/Person";
import VisibilityIcon from "@mui/icons-material/Visibility";

export const resume_stages = [
  "New Application Received",
  "Screening",
  "Invited",
  "Rejected",
  "Passed",
  "Interviewed",
  "Interview result generated",
  "Offer Sent",
  "Hired",
];
export const interview_stages = [
  "Invited",
  "Interviewed",
  "Withdraw",
  "Interview result generated",
  "Offer Sent",
  "Hired",
];

export const flows = {
  1: {
    title: "Post a Job",
    bgcolor: "#ECF7E6",
    color: "#93D373",
  },
  2: {
    title: "Import Candidates",
    bgcolor: "#E8F8FB",
    color: "#56CAE3",
  },
  3: {
    title: "Conduct Assessment",
    bgcolor: "#FFF8E9",
    color: "#FFC336",
  },
  4: {
    title: "Full Recruitment",
    bgcolor: "#F1E8FE",
    color: "#B483FC",
  },
};

export const options = {
  experience: [
    "Less than 6 months",
    "6 months - 1 year",
    "1-2 years",
    "2-3 years",
    "3-4 years",
    "4-5 years",
    "5-7 years",
    "7-10 years",
    "10-12 years",
    "12-15 years",
    "15+ years",
  ],

  skills: [
    "Java",
    "Python",
    "JavaScript",
    "TypeScript",
    "C",
    "C++",
    "C#",
    "Go",
    "Rust",
    "Ruby",
    "PHP",
    "Swift",
    "Kotlin",
    "HTML",
    "CSS",
    "SASS/SCSS",
    "React",
    "Angular",
    "Vue.js",
    "Next.js",
    "Nuxt.js",
    "Node.js",
    "Express.js",
    "NestJS",
    "SQL",
    "MySQL",
    "PostgreSQL",
    "SQLite",
    "MongoDB",
    "Redis",
    "Elasticsearch",
    "Firebase",
    "AWS",
    "Azure",
    "Google Cloud",
    "Heroku",
    "Vercel",
    "Netlify",
    "Docker",
    "Kubernetes",
    "Terraform",
    "Jenkins",
    "Git",
    "GitHub Actions",
    "CI/CD",
    "Machine Learning",
    "Deep Learning",
    "Computer Vision",
    "NLP",
    "Data Analysis",
    "Data Engineering",
    "Big Data",
    "Pandas",
    "NumPy",
    "Tableau",
    "Power BI",
    "Apache Spark",
    "Hadoop",
    "Linux",
    "Bash/Shell Scripting",
    "Photoshop",
    "Illustrator",
    "Figma",
    "UI/UX Design",
    "Accessibility",
    "SEO",
    "Content Writing",
    "Technical Writing",
    "Agile Methodologies",
    "Scrum",
    "JIRA",
    "Salesforce",
    "SAP",
    "Financial Modeling",
    "R",
    "MATLAB",
    "SAS",
    "Blockchain",
    "Solidity",
    "Smart Contracts",
    "Cybersecurity",
  ],
  soft_skills: [
    "Communication",
    "Teamwork",
    "Conflict Resolution",
    "Time Management",
    "Planning and Scheduling",
    "Attention to Detail",
    "Decision Making",
    "Delegation",
    "Motivational Skills",
    "Critical Thinking",
    "Creativity",
    "Analytical Reasoning",
    "Flexibility",
    "Emotional Intelligence",
    "Learning Agility",
    "Empathy",
    "Negotiation",
    "Client Handling",
    "Responsibility",
    "Dedication",
    "Integrity",
    "Adaptability",
    "Problem Solving",
    "Presentation Skills",
    "Leadership",
    "Public Speaking",
    "Work Ethic",
    "Collaboration",
    "Confidence",
    "Interpersonal Skills",
    "Resilience",
    "Cultural Awareness",
    "Initiative",
    "Accountability",
  ],
  certificates: ["Yes", "No"],
  achievements: ["Yes", "No"],
};

export const roles = {
  Admin: {
    label: "Admin",
    description: "Full system access with billing and user management",
    permissions: [
      "Create, edit, delete job postings",
      "Create & conduct assessments",
      "Share candidates results",
      "Import & manage candidates",
      "Full recruitment pipeline access",
      "Invite team members (all roles)",
      "Manage billing & settings",
    ],
    color: "error",
    icon: SupervisorAccountIcon,
  },
  User: {
    label: "User",
    description: "Standard access for recruitment activities",
    permissions: [
      "Create, edit, delete job postings",
      "Create & conduct assessments",
      "Share candidates results",
      "Import & manage candidates",
      "Full recruitment pipeline access",
    ],
    color: "primary",
    icon: PersonIcon,
  },
  // "Read only": {
  //   label: "Read only",
  //   description: "View-only access to all recruitment data",
  //   permissions: [
  //     "View job postings",
  //     "View assessments",
  //     "View candidates results",
  //     "View recruitment pipeline",
  //   ],
  //   color: "default",
  //   icon: VisibilityIcon,
  // },
};
